<script>
import { Line } from "vue-chartjs"
import AuditAPI from "../api/audit/audit"
export default {
	extends: Line,
	data(){
		return{
			auditRequestsAssessed:[],
			auditRequestsSent:[]
		}
	},
	mounted() {
		this.getEachMonthData()
	},
	methods:{
		async getEachMonthData(){
			let dataArray = await AuditAPI.getAuditDashboard()

			let requestAssessed=dataArray.map(data=>data.audits_assessed)
			let requestSent=dataArray.map(data=>data.audit_requests)

			this.auditRequestsAssessed=requestAssessed
			this.auditRequestsSent=requestSent

			this.renderChart(
				{
					labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"],
					datasets: [
						{
							label: "Audits assessed",
							data: this.auditRequestsAssessed,
							backgroundColor: "transparent",
							borderColor: "#3498DB",
							pointBackgroundColor: "#3498DB",
						},
						{
							label: "Audit requests sent",
							data: this.auditRequestsSent,
							backgroundColor: "transparent",
							borderColor: "#E74C3C",
							pointBackgroundColor: "#E74C3C"
						}
					]
				},
				{
					responsive: true,
					maintainAspectRatio: false,
					title: {
						display: false,
					},
					scales: {
						yAxes: [{
							ticks: {
								beginAtZero:true
							}
						}]
					}
				}
			)

		}
	}
}
</script>